import { render, staticRenderFns } from "./arrow-up-light.vue?vue&type=template&id=b752a650&"
import script from "./arrow-up-light.vue?vue&type=script&lang=js&"
export * from "./arrow-up-light.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b752a650')) {
      api.createRecord('b752a650', component.options)
    } else {
      api.reload('b752a650', component.options)
    }
    module.hot.accept("./arrow-up-light.vue?vue&type=template&id=b752a650&", function () {
      api.rerender('b752a650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/arrow-up-light.vue"
export default component.exports